// import moment from 'moment'

export default {
  getAdmins (VueApp, data, callback) {
    let admin = VueApp.$store.state.admin
    VueApp.$sdk.get('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      search: admin.search,
      status: admin.status,
      order: admin.order,
      orderAsc: admin.orderAsc,
      pageNum: admin.currentPage,
      pageSize: admin.perPage
    }, res => {
      if (!res.error) {
        let admins = []
        res.list.forEach(function (data) {
          let reportPermissions = {}
          for (var i in admin.reportsList) {
            reportPermissions[i] = data.access.permissions[i] || ''
          }
          
          admins.push({
            id: data.id,
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            username: data.username,
            email: data.email,
            mobile: data.phone,
            isActive: data.isActive,
            permission: data.access.permissions,
            reportPermissions: reportPermissions
          })
        })
        VueApp.$store.commit('admin/setList', admins)
        VueApp.$store.commit('admin/setMaxList', res.paging.totalItems)
      }
      callback(res)
    })
  },
  getAdminList (VueApp) { // Used in notes? (tagging admin)
    VueApp.$sdk.get('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'firstName',
      pageSize: 999
    }, r => {
      if (r.error) {
        // TODO: Handle Error
        VueApp.$store.commit('reservationNotes/setAdmins', [{id: 0, name: ''}])
        return
      }

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        if (r.list[i].firstName && r.list[i].lastName) {
          result.push({
            id: r.list[i].id,
            name: r.list[i].firstName + ' ' + r.list[i].lastName
          })
        }
      }

      VueApp.$store.commit('reservationNotes/setAdmins', result)
    })
  },
  getAdmin (VueApp, id, callback) {
    VueApp.$sdk.get('/admin/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  updateAdmin (VueApp, data, callback) {
    VueApp.$sdk.post('/admin/' + data.id, {
      token: VueApp.$store.state.session.sessionToken,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.mobile,
      username: data.username
    }, res => {
      callback(res)
    })
  },
  updateAdminPassword (VueApp, data, callback) {
    VueApp.$sdk.post('/admin/' + data.id + '/password', {
      token: VueApp.$store.state.session.sessionToken,
      password: data.password
    }, res => {
      callback(res)
    })
  },
  addAdmin (VueApp, data, callback) {
    VueApp.$sdk.post('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      phone: data.mobile,
      username: data.username,
      password: data.password
    }, res => {
      callback(res)
    })
  },
  updateAdminAccess (VueApp, id, callback) {
    let admin = VueApp.$store.state.admin
    let access = admin.permissions
    let reportPermissions = admin.reportPermissions

    let accessList = Object.assign({}, admin.accessList)
    for (let key in accessList) {
      accessList[key] = access[key] ? 'view' : ''
    }

    let reportsList = Object.assign({}, admin.reportsList)
    for (let key in reportsList) {
      if (accessList.PageAdminReports === 'view') accessList[key] = reportPermissions[key] ? 'view' : ''
      else accessList[key] = ''
    }
    // accessList.reportsAccess = JSON.stringify(reportsList)
    // if (accessList.PageAdminReports && Object.keys(reportPermissions).length) {
    // }
    VueApp.$sdk.post('/admin/' + id + '/access', {
      token: VueApp.$store.state.session.sessionToken,
      access: accessList
    }, res => {
      callback(res)
    })
  },
  updateStatus (VueApp, data, callback) {
    if (data.deactivate) {
      VueApp.$sdk.delete('/admin/' + data.id, {
        token: VueApp.$store.state.session.sessionToken
      }, res => {
        callback(res)
      })
    } else {
      VueApp.$sdk.post('/admin/' + data.id, {
        token: VueApp.$store.state.session.sessionToken,
        deleted: null
      }, res => {
        callback(res)
      })
    }
  },
  export (VueApp, callback) {
    let self = this
    let admin = VueApp.$store.state.admin
    VueApp.$sdk.get('/admin', {
      token: VueApp.$store.state.session.sessionToken,
      search: admin.search,
      status: admin.status,
      order: admin.order,
      orderAsc: admin.orderAsc,
      pageNum: admin.currentPage,
      pageSize: admin.perPage
    }, res => {
      if (!res.error) {
        let admins = []
        if (res.list.length) {
          res.list.forEach(function (value) {
            admins.push(self.buildExportAll(value))
          })
        }
        callback(admins)
      } else {
        callback(res)
      }
    })
  },
  buildExportAll (data) {
    let created = ''
    if (data.created) {
      let temp = moment(data.created, 'YYYY-MM-DD HH:mm:ss')
      if (temp.isValid()) {
        created = temp.format('MM/DD/YYYY HH:mm:ss')
      }
    }
    return {
      'First Name': data.firstName,
      'Last Name': data.lastName,
      'Username': data.username,
      'Email': data.email,
      'Mobile': data.phone,
      'Active': data.isActive
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/admin/index.js